import React from 'react'
import Button from 'react-bootstrap/Button';

export const CancelButton = (props) => {
  return (
    <Button
      label={props.label}
      className={'btn-fill pull-right '+props.className}
      variant="danger"
      disabled={props.disabled ? true : false}
      onClick={props.onClick}
    >{props.label}</Button>
  )
}
